import { LoginOutput } from 'dtos/users/LoginOutput';
import { makeAutoObservable, runInAction } from 'mobx';
import { createForm } from 'forms/loginForm';
import { Match } from 'navigo';
import { serverUri } from 'utils/config';
import { nullsToUndefined } from 'utils/nullsToUndefined';
import { HttpException, LoadStatus } from 'utils/types';
import { AuthStore } from 'stores/users/AuthStore';
import { SocialAuthStore } from 'stores/users/SocialAuthStore';
import { emailIsNotConfirmedMessage } from 'dtos/users/common';
import { ConfirmEmailStore } from './ConfirmEmailStore';

export class LoginStore {
  form = createForm();
  status: LoadStatus = 'none';
  message?: string;

  constructor(
    private readonly authStore: AuthStore,
    private readonly socialAuthStore: SocialAuthStore,
    private readonly confirmEmailStore: ConfirmEmailStore
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  activate(match: Match) {
    this.status = 'none';
    this.message = undefined;
    this.form.reset();
    this.socialAuthStore.reset();
  }

  login = async () => {
    try {
      this.status = 'loading';
      this.message = undefined;
      this.socialAuthStore.reset();
      const { email, password } = this.form.values();
      const query = { email, password };
      const response = await fetch(`${serverUri}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(query),
      });
      if (response.ok) {
        this.form.reset();
        const output: LoginOutput = nullsToUndefined(await response.json());
        this.authStore.handleLoginResponse(output);
      } else {
        const exception: HttpException = nullsToUndefined(await response.json());
        if (exception.message === emailIsNotConfirmedMessage) {
          this.confirmEmailStore.resendEmail(email);
        } else {
          runInAction(() => {
            this.status = 'error';
            this.message = `Unable to log in.${exception.message ? ` ${exception.message}` : ''} Please try again.`;
          });
        }
      }
    } catch (err) {
      runInAction(() => {
        this.status = 'error';
        this.message = `Unable to log in.${err instanceof Error ? ` ${err.message}` : ''} Please try again.`;
      });
    }
  };
}
